module.exports = __webpack_public_path__ + "assets/08f564bce6dafc02322e8d1cdc5c37ed.svg";